import RestClient from '../RestClient/RestClient';

/**
 * A simple function to parse cookie string and get specific cookie value based on requested cookie name.
 * @params - key - Cookie name.
 */
export const getCookie = (key) => { //eslint-disable-line
    const context = RestClient.getContext();
    let cookies = '';
    /* istanbul ignore if */
    if (context.isBrowser) {
        cookies = document.cookie;
    } else {
        cookies = context.headers.cookie;
    }
    const cookie = `; ${cookies}`.match(`;\\s*${key}=([^;]+)`);
    return cookie ? cookie[1] : '';
};

export default class Cookies {
    static getCookie(key) {
        return getCookie(key);
    }
}
